<div class='AccountSettings'>
  <div class='PrefsPipeline-header d-flex flex-row'>
    <div class='flex-grow-1'>
      <h4>Retreva's Zoho Integration</h4>
    </div>
    <div class='flex-grow-0'>
      <a [routerLink]="['/messages']">Back to Inbox</a>
    </div>
  </div>

  <p>
    This account currently does not synchronize with Zoho. If enabled, whenever
    you add or change Leads in Zoho or Contacts in Retreva this process will
    keep the information in sync.
  </p>
  <p>
    If you wish to enable synchronization of this information click on the
    button below.
  </p>
  <div class='container'>
    <div class='AccountSettings-buttons row'>
      <app-button
        [color]='syncButtonProperties.color'
        [route]='syncButtonProperties.route'
        [size]='syncButtonProperties.size'
        [text]='syncButtonProperties.text'
        class='AccountSettings-buttons-button col col-12 col-md-6'></app-button>
    </div>
  </div>
</div>
